var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4999 49.2917C13.6363 49.2917 3.20825 38.8636 3.20825 26C3.20825 13.1364 13.6363 2.70834 26.4999 2.70834C39.3635 2.70834 49.7916 13.1364 49.7916 26C49.7916 38.8636 39.3635 49.2917 26.4999 49.2917Z",
    fill: "#4BAF55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7637 20.9641C37.5723 20.082 37.5127 18.7114 36.6306 17.9028C35.7485 17.0943 34.3779 17.1539 33.5693 18.0359L23.1818 29.3678L19.3652 25.5513C18.5191 24.7051 17.1472 24.7051 16.3011 25.5513C15.455 26.3974 15.455 27.7693 16.3011 28.6154L21.7178 34.0321C22.1356 34.45 22.7061 34.679 23.2969 34.6662C23.8877 34.6533 24.4477 34.3997 24.847 33.9641L36.7637 20.9641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.684ba6af6560dc2c48da46fa84d8fee0.svg";
export { ForwardRef as ReactComponent };